import { useState } from "react";
import { toast } from "sonner";
import { Camera, Loader2, X } from "lucide-react";
import { api, errMsg, photoUrl } from "@/lib/api";

export const PhotoThumbs = ({ photos, onRemove }) => (
  <div className="flex flex-wrap gap-2">
    {photos.map((p) => (
      <div key={p} className="relative">
        <a href={photoUrl(p)} target="_blank" rel="noreferrer">
          <img src={photoUrl(p)} alt="Issue" className="h-20 w-20 rounded-lg border object-cover" data-testid="issue-photo-thumb" />
        </a>
        {onRemove && (
          <button type="button" onClick={() => onRemove(p)} className="absolute -right-2 -top-2 rounded-full bg-destructive p-1 text-white" aria-label="Remove photo">
            <X className="h-3 w-3" />
          </button>
        )}
      </div>
    ))}
  </div>
);

export const PhotoUpload = ({ photos, onChange, testId }) => {
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const files = [...e.target.files];
    e.target.value = "";
    if (!files.length) return;
    setBusy(true);
    try {
      const added = [];
      for (const f of files) {
        const fd = new FormData();
        fd.append("file", f);
        const { data } = await api.post("/photos", fd);
        added.push(data.path);
      }
      onChange([...photos, ...added]);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="space-y-2">
      <PhotoThumbs photos={photos} onRemove={(p) => onChange(photos.filter((x) => x !== p))} />
      <label className="inline-flex cursor-pointer items-center gap-2 rounded-full border px-4 py-2 text-sm font-semibold hover:bg-secondary">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Camera className="h-4 w-4" />} Add photo
        <input type="file" accept="image/*" capture="environment" multiple className="hidden" onChange={pick} data-testid={testId} />
      </label>
    </div>
  );
};
